export const capitalizeFirstLetter = (string) => {
    if (typeof string !== "string") return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function addPrintableClass() {
    // Get all elements with the class name "to_be_print"
    const elements = document.getElementsByClassName("to_be_print");

    // Loop through the elements and add the "printable" class to each one
    for (let i = 0; i < elements.length; i++) {
        elements[i].classList.add("printable");
    }
}
export function removePrintableClass() {
    // Get all elements with the class name "to_be_print"
    const elements = document.getElementsByClassName("to_be_print");

    // Loop through the elements and add the "printable" class to each one
    for (let i = 0; i < elements.length; i++) {
        elements[i].classList.remove("printable");
    }
}


export const converMarkToHtml = (lessonData) => {
    if (!lessonData) return "";
    const lines = lessonData.split("\n");
    // const lines = lessonData?.replace(/^```html\s*/i, '').replace(/```$/i, '')?.split("\n");
    let html = `
      <div class="lesson-plan" style="
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        line-height: 1.6;
        color: #333;
        max-width: 800px;
        margin: 0 auto;
        padding: 0px 20px 20px 20px;
        background-color: #fafafa;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      ">
    `;
  
    let listOpen = false;
    let subListLevel = 0;
  
    lines.forEach((line) => {
      const trimmed = line.trim();
  
      if (trimmed.startsWith("###")) {
        if (listOpen) {
          html += "</ul>";
          listOpen = false;
          subListLevel = 0;
        }
        html += `<h3 style="color: #2c3e50; font-size: 1.2em; margin-top: 10px;font-weight:bold;">${trimmed.replace(/^###\s*/, "")}</h3>`;
      }
  
      else if (trimmed.startsWith("##")) {
        if (listOpen) {
          html += "</ul>";
          listOpen = false;
          subListLevel = 0;
        }
        html += `<h2 style="color: #1a252f; font-size: 1.4em; border-bottom: 1px solid #ccc; padding-bottom: 4px; margin-top: 8px; font-weight:bold;">${trimmed.replace(/^##\s*/, "")}</h2>`;
      }
  
      else if (trimmed.startsWith("**")) {
        const boldParts = trimmed.split("**").filter(Boolean);
        html += `<p style="font-weight: bold; margin: 10px 0;">${boldParts.join("</p><p style='font-weight: bold; margin: 10px 0;'>")}</p>`;
      }
  
      else if (trimmed.startsWith("    - ")) {
        if (subListLevel < 2) {
          html += "<ul style='padding-left: 40px;'>";
          subListLevel = 2;
          listOpen = true;
        }
        html += `<li>${trimmed.replace(/^ {4}-\s*/, "")}</li>`;
      }
  
      else if (trimmed.startsWith("  - ")) {
        if (subListLevel < 1) {
          html += "<ul style='padding-left: 30px;'>";
          subListLevel = 1;
          listOpen = true;
        }
        html += `<li>${trimmed.replace(/^ {2}-\s*/, "")}</li>`;
      }
  
      else if (trimmed.startsWith("- ")) {
        if (!listOpen) {
          html += "<ul style='padding-left: 20px;'>";
          listOpen = true;
          subListLevel = 0;
        }
        html += `<li>${trimmed.replace(/^- /, "")}</li>`;
      } else if (/^```/.test(trimmed)) {
        if (listOpen) {
          html += "";
          listOpen = false;
          subListLevel = 0;
        }
      }
  
      else {
        if (listOpen) {
          html += "</ul>";
          listOpen = false;
          subListLevel = 0;
        }
        html += `<p style="margin: 10px 0;">${trimmed}</p>`;
      }
    });
  
    if (listOpen) {
      html += "</ul>";
    }
  
    html += "</div>";
    return html;
};

export function cleanHTMLString(input) {
  return input
    .trim()
    .replace(/^h1>\s*(.*)/i, "<h1>$1</h1>") // Fix malformed <h1>
    .replace(/ul>\s*([A-Za-z])/g, "$1") // Remove stray 'ul>'
    // Convert lines that look like list items but are plain text
    .replace(
      /(Objectives|Essential Questions|Can-Do Statements|Activities)\s*[\r\n]+(?!<)/gi,
      (match, p1) => `${p1}\n<ul>`
    )
    .replace(
      /^(\s*)([A-Za-z][^:]*?:\s*.*)$/gm,
      (match, p1, p2) => {
        if (p2.startsWith('<li') || p2.startsWith('<h1') || p2.startsWith('<p')) {
          return match;
        }
        return `${p1}<li>${p2}</li>`;
      }
    )
    .replace(/^(Day\s*\d+)$/gmi, '<h2>$1</h2>') // Convert "Day X" to H2
    // General cleaning
    .replace(/<<\s*/g, "<")
    .replace(/>>/g, ">")
    .replace(/<\s+</g, "<")
    .replace(/<\s+/g, "<")
    .replace(/\s+>/g, ">")
    .replace(/<([^>\s]+)[^>]*>/g, "<$1>")
    .replace(/<\/?[^a-z0-9]+>/gi, "")
    .replace(/&nbsp;/g, " ")
    .replace(/<br\s*\/?>/gi, "")
    .replace(/html\d*>/gi, "")
    .replace(/[\r\n]{3,}/g, '\n\n')
    .replace(/```html\s*/g, "")
    .replace(/```\s*/g, "")
}
  
export const converMarkToHtmlText = (lessonData) => {
  const lines = lessonData?.split("\n");
  let html = `
    <div class="lesson-plan" style="
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      line-height: 1.6;
      color: #333;
      max-width: 800px;
      margin: 0 auto;
      padding: 20px;
      background-color: #fafafa;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    ">
  `;

  let listOpen = false;
  let subListLevel = 0;

  lines.forEach((line) => {
    const trimmed = line.trim();

    const hideHash = (text) => {
      // Replace only first # at start of line
      return text.replace(/^#/, `<span style="display: none;">#</span>`);
    };

    if (/^#{1}\s+/.test(trimmed)) {
      // Single # header
      if (listOpen) {
        html += "</ul>";
        listOpen = false;
        subListLevel = 0;
      }

      let content = trimmed.replace(/^#\s*/, "");
      content = hideHash(trimmed); // Hide the # visually, but keep text

      html += `<h1 style="font-size: 1.4em; font-weight: bold; margin-top: 1em;">${content}</h1>`;
    } else if (/^```/.test(trimmed)) {
      if (listOpen) {
        html += "";
        listOpen = false;
        subListLevel = 0;
      }
    }

    else if (trimmed.startsWith("###")) {
      if (listOpen) {
        html += "</ul>";
        listOpen = false;
        subListLevel = 0;
      }

      let content = trimmed.replace(/^###\s*/, "");
      content = hideHash(content);

      html += `<h3 style="color: #2c3e50; font-size: 1.2em; margin-top: 1.5em;font-weight:bold;">${content}</h3>`;
    }

    else if (trimmed.startsWith("##")) {
      if (listOpen) {
        html += "</ul>";
        listOpen = false;
        subListLevel = 0;
      }

      let content = trimmed.replace(/^##\s*/, "");
      content = hideHash(content);

      html += `<h2 style="color: #1a252f; font-size: 1.4em; border-bottom: 1px solid #ccc; padding-bottom: 4px; margin-top: 8px; font-weight:bold;">${content}</h2>`;
    }

    else if (trimmed.startsWith("**")) {
      const boldParts = trimmed.split("**").filter(Boolean);
      html += `<p style="font-weight: bold; margin: 10px 0;">${boldParts.join("</p><p style='font-weight: bold; margin: 10px 0;'>")}</p>`;
    }

    else if (trimmed.startsWith("    - ")) {
      if (subListLevel < 2) {
        html += "<ul style='padding-left: 40px;'>";
        subListLevel = 2;
        listOpen = true;
      }
      html += `<li>${trimmed.replace(/^ {4}-\s*/, "")}</li>`;
    }

    else if (trimmed.startsWith("  - ")) {
      if (subListLevel < 1) {
        html += "<ul style='padding-left: 30px;'>";
        subListLevel = 1;
        listOpen = true;
      }
      html += `<li>${trimmed.replace(/^ {2}-\s*/, "")}</li>`;
    }

    else if (trimmed.startsWith("- ")) {
      if (!listOpen) {
        html += "<ul style='padding-left: 20px;'>";
        listOpen = true;
        subListLevel = 0;
      }
      html += `<li>${trimmed.replace(/^- /, "")}</li>`;
    }

    else {
      if (listOpen) {
        html += "</ul>";
        listOpen = false;
        subListLevel = 0;
      }
      html += `<p style="margin: 10px 0;">${trimmed}</p>`;
    }
  });

  if (listOpen) {
    html += "</ul>";
  }

  html += "</div>";
  return html;
};

export function isYoutubeUrl(url) {
  const pattern = /^(https?:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
  return pattern.test(url);
}

export const getUserIntegrationDetail = (user) => {
  if (!user) return;
  const { cleverId, classlinkid, googleId, email, canvas_id, schoologyid } = user;
  if (classlinkid) {
    return (
      <p>
        <strong>Classlink Id:</strong>{' '}
        {classlinkid}
      </p>
    )
  } else if (cleverId) {
    return (
      <p>
        <strong>Clever Id:</strong>{' '}
        {cleverId}
      </p>
    )
  } else if (googleId) {
    return (<>
      <p>
        <strong>google Id:</strong>{' '}
        {googleId}
      </p>
      <p>
        <strong>Email:</strong>{' '}
        {email}
      </p>
    </>
    )
  } else if (canvas_id) {
    return (
      <p>
        <strong>Canvas Id:</strong>{' '}
        {canvas_id}
      </p>
    )
  } else if (schoologyid) {
    return (
      <p>
        <strong>Schoology Id:</strong>{' '}
        {schoologyid}
      </p>
    )
  }
  return null;
}

export const checkStandardExam = (chapter, standard_exams) => {
  if(!chapter || !standard_exams) return false;
  try {
    const standardExamBookIds = Array.isArray(standard_exams) && standard_exams.length > 0 ? standard_exams.flatMap((entry) =>
      entry && entry.standard_exams && Array.isArray(entry.standard_exams) ? entry.standard_exams.map((exam) => `${exam.bookId}`) : []
    ) : [];
    return standardExamBookIds.includes(String(chapter))
  } catch (error) {
    console.log(error);
    return false;
  }
}